import type {
    IntentCountryDto,
    IntentCountryScopeDto,
} from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import CountryService from "app/services/CountryService";

const compareNamesAsc = <T extends { country: string }>(a: T, b: T): number => {
    return a.country.trim().toLowerCase().localeCompare(b.country.trim().toLowerCase());
};

export const getIntentSignalCountries = (countries: readonly IntentCountryDto[]): readonly IntentCountryScopeDto[] => {
    const countriesMap = new Map<number, IntentCountryScopeDto>();

    countries.forEach(({ countryCode, city, country }: IntentCountryDto) => {
        if (!CountryService.isCountrySupported(countryCode)) {return;}

        let countryData = countriesMap.get(countryCode);

        if (countryData) {
            if (city) {countryData.cities.push(city);}
        } else {
            countryData = {
                country: country,
                countryCode: countryCode,
                cities: city ? [city] : [],
            };

            countriesMap.set(countryCode, countryData);
        }
    });

    return Array.from(countriesMap.values()).sort(compareNamesAsc);
};
